"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = void 0;
var _mui = require("@ori-ui/mui");
var _shared = require("../shared");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')(({
  theme
}) => {
  const {
    base
  } = (0, _shared.decoratedHeaderStyles)(theme, 'mainBanner');
  return {
    textAlign: 'center',
    ...base
  };
});
const Text = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  fontWeight: 'bold',
  lineHeight: 1.2,
  margin: theme.spacing(3, 8)
}));
const Header = ({
  title
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(Root, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Text, {
    color: "inherit",
    variant: "h6",
    children: title
  })
});
exports.Header = Header;